import { UUID } from "@bitory-gmbh/nidavellir";
import {
  PatchRequest,
  updateHtzSummaryCache,
  useHtzSummaryPatchMutation,
  useHtzSummaryShowQuery,
} from "@/services/backend/htz/summary/api/summary-api";
import { CardContentSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { useOptimisticDebouncedMutation } from "@/shared/lib/debounce/use-optimistic-debounced-mutation";
import { EditorInputField } from "@/shared/components/field/editor-input-field";

export function SummaryCoverLetterCard({
  id,
  disabled,
}: {
  id: UUID;
  disabled?: boolean;
}) {
  const {
    data,
    error: dataError,
    isLoading: dataLoading,
  } = useHtzSummaryShowQuery({ id });

  const request: PatchRequest = { id };
  const [set] = useOptimisticDebouncedMutation(
    request,
    updateHtzSummaryCache,
    useHtzSummaryPatchMutation(),
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Anschreiben")}</CardTitle>
        <CardDescription>
          {t(
            "Text, mit dem der Kunde angesprochen wird. Er steht vor der Übersicht der Anlagen.",
          )}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {dataError && <RTKQueryErrorAlert error={dataError} />}
        {dataLoading && <CardContentSkeleton />}
        {data && (
          <EditorInputField
            initialHtml={data.coverLetter}
            onHtmlChange={(coverLetter: string) => {
              set({ ...request, coverLetter }, { ...data, coverLetter });
            }}
            fieldName="coverLetter"
            disabled={disabled}
          />
        )}
      </CardContent>
    </Card>
  );
}
